import { render, staticRenderFns } from "./MapPlaceholder.vue?vue&type=template&id=d40cd06a&scoped=true&"
import script from "./MapPlaceholder.vue?vue&type=script&lang=js&"
export * from "./MapPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./MapPlaceholder.vue?vue&type=style&index=0&id=d40cd06a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40cd06a",
  null
  
)

export default component.exports